module.exports = __webpack_public_path__ + "9b3b145ad4e7065b1467a5b971aeabe7.xml";